import { render, staticRenderFns } from "./xsmx.vue?vue&type=template&id=63dabd38&scoped=true&"
import script from "./xsmx.vue?vue&type=script&lang=js&"
export * from "./xsmx.vue?vue&type=script&lang=js&"
import style0 from "./xsmx.vue?vue&type=style&index=0&id=63dabd38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dabd38",
  null
  
)

export default component.exports